
<template>
    <a class="button button--share-pdf" target="_blank" title="Download page as PDF" :href="host + '/' + target + '/' + id">
        <i class="icon-pdf"></i>
    </a>
</template>

<script>
export default {
    props: ["id"],
    data() {
        return {
            host: "https://zbgfwlujh8.execute-api.us-east-1.amazonaws.com/dev/pdf",
            target: "dev"
        }
    },
    mounted() {
        this.getTarget()
    },
    methods: {
        getTarget: function () {
            if (window.location.host === "localhost:5001") {
                this.target = "local";
            }
            if (window.location.host === "dev-o-melveny.useast01.umbraco.io") {
                this.target = "dev";
            }
            if (window.location.host === "stage-o-melveny.useast01.umbraco.io") {
                this.target = "stage";
            }
            if (window.location.host === "omm-uat.incendiaryblue.com") {
                this.target = "uat";
            }
            if (window.location.host === "www.omm.com" || window.location.host === "omm.com") {
                this.target = "prod";
            }
        }
    }
}
</script>